import { z } from 'zod';
import { ArrayOfUniqueStrings } from "./utils";
var validateEnumNames = function validateEnumNames(data) {
  var _data$xEnumNames;
  return !('x-enumNames' in data) || data["enum"].length === ((_data$xEnumNames = data['x-enumNames']) === null || _data$xEnumNames === void 0 ? void 0 : _data$xEnumNames.length);
};
export var EnumDisplayNameRefinement = {
  message: "The length of 'enum' and 'x-enumNames' must be equal",
  path: ['x-enumNames']
};

/**
 * These are zod schemas that describe a subset of the JsonSchema standard, with
 * some AB-specific concerns.
 *
 * ❗❗ Be careful when changing these schemas to ensure we stay compliant with the
 * JsonSchema standard. Check the following url: https://json-schema.org/ ❗❗
 */

var JsonSchemaStringBase = z.object({
  title: z.string(),
  type: z.literal('string'),
  "enum": ArrayOfUniqueStrings,
  'x-enumNames': ArrayOfUniqueStrings.optional()
});
var JsonSchemaString = JsonSchemaStringBase.refine(validateEnumNames, EnumDisplayNameRefinement);
var JsonSchemaStringWithDescription = JsonSchemaStringBase.extend({
  description: z.string()
}).refine(validateEnumNames, EnumDisplayNameRefinement);
var JsonSchemaBoolean = z.object({
  title: z.string(),
  type: z.literal('boolean')
});
var JsonSchemaNumber = z.object({
  title: z.string(),
  type: z.union([z.literal('number'), z.literal('integer')]),
  'x-type': z.union([z.literal('program-id'), z.literal('school-group-id')])
});
var JsonSchemaStringEnumArray = z.object({
  title: z.string(),
  type: z.literal('array'),
  items: z.object({
    type: z.literal('string'),
    "enum": ArrayOfUniqueStrings,
    'x-enumNames': ArrayOfUniqueStrings.optional()
  }).refine(validateEnumNames, EnumDisplayNameRefinement)
});
var JsonSchemaDateString = z.object({
  title: z.string(),
  type: z.literal('string'),
  format: z.union([z.literal('date'), z.literal('date-time')])
});
export var JsonSchemaProperty = z.union([JsonSchemaString, JsonSchemaStringWithDescription, JsonSchemaBoolean, JsonSchemaNumber, JsonSchemaDateString, JsonSchemaStringEnumArray]);
export var JsonSchema = z.discriminatedUnion('type', [z.object({
  title: z.string(),
  type: z.literal('object'),
  properties: z.record(z.string(), z.union([JsonSchemaDateString, JsonSchemaStringWithDescription, JsonSchemaBoolean, JsonSchemaNumber]))
}), z.object({
  title: z.string(),
  type: z.literal('array'),
  items: z.object({
    type: z.literal('object'),
    properties: z.record(z.string(), z.union([JsonSchemaString, JsonSchemaStringEnumArray, JsonSchemaBoolean, JsonSchemaDateString]))
  })
})]);
export var QuestionOptionsPropertySchema = z.object({
  type: z.literal('object'),
  title: z.string(),
  'x-type': z.literal('form-question-options'),
  properties: z.object({
    question_key: z.object({
      type: z.literal('string'),
      format: z.literal('form-question')
    }),
    option_keys: z.object({
      type: z.literal('array'),
      items: z.object({
        type: z.literal('string'),
        format: z.literal('form-question-option-short')
      })
    })
  })
});